/**
 * ESGデータ用のステータス
 */
export const EsgDataStatus = {
  ANSWERING: 'ANSWERING', // 回答中
  INVITING: 'INVITING', // 招待中
  SHARING: 'SHARING', // 共有中
  UNSHARED: 'UNSHARED', // 閲覧終了/共有終了
  // MEMO: 共有解除状態のステータスが追加されるかも
} as const

export type EsgDataStatusType = typeof EsgDataStatus[keyof typeof EsgDataStatus]

export const isAnswering = (status: EsgDataStatusType): boolean => {
  switch (status) {
    case EsgDataStatus.ANSWERING:
      return true
    case EsgDataStatus.INVITING:
    case EsgDataStatus.SHARING:
    case EsgDataStatus.UNSHARED:
      return false
    default:
      throw new Error(`${status satisfies never} is unexpected value`)
  }
}

/**
 * サプライヤー側の回答状況を表すステータス
 */
export type EsgDataAnsweringStatusType
  = Exclude<EsgDataStatusType, typeof EsgDataStatus.ANSWERING | typeof EsgDataStatus.UNSHARED>

/**
 * サプライヤー側が共有したか否かを表すステータス
 */
export type EsgDataSharingStatusType
  = Exclude<EsgDataStatusType, typeof EsgDataStatus.ANSWERING>
/**
 * サプライヤー側が共有したか否かを表すステータスの配列
 */
export const EsgDataSharingStatusList = [EsgDataStatus.INVITING, EsgDataStatus.SHARING, EsgDataStatus.UNSHARED]

/**
 * バイヤー側が共有されたか否かを表すステータス
 */
export type EsgDataSharedStatusType
  = Exclude<EsgDataStatusType, typeof EsgDataStatus.ANSWERING | typeof EsgDataStatus.INVITING>

/**
 * ESGデータの中項目用のステータス
 */
export const EsgDataBundleCategory = {
  COMPANY_INFO: 'COMPANY_INFO',
  CO2_ACTIVITY: 'CO2_ACTIVITY',
  INITIATIVE: 'INITIATIVE',
  INTENSITY: 'INTENSITY',
  GHG: 'GHG',
  ENVIRONMENT_INFO: 'ENVIRONMENT_INFO',
  BASIC_INFO: 'BASIC_INFO',
  HUMAN_CAPITAL: 'HUMAN_CAPITAL',
  HEALTH_SAFETY: 'HEALTH_SAFETY',
  LABOR_HUMAN_RIGHTS_DEI: 'LABOR_HUMAN_RIGHTS_DEI',
  GOVERNANCE: 'GOVERNANCE',
  STRATEGY: 'STRATEGY',
  COMPLIANCE_RISK: 'COMPLIANCE_RISK',
  INFORMATION_SECURITY: 'INFORMATION_SECURITY',
} as const
export type EsgDataBundleCategoryType = typeof EsgDataBundleCategory[keyof typeof EsgDataBundleCategory]
